import React from 'react';

const AngelProblemSection = () => (
    <section className="lp-split">
        <div className="lp-split-inner">
            <div className="c">
                <h2 className="lp-h2" data-lp-reveal>The conflict between volume and quality.</h2>
                <p className="lead" data-lp-reveal data-lp-delay="80">Networks need fee-paying applicants to survive — which creates pressure to accept companies regardless of readiness. The result is an overwhelmed IC, members who feel their time is wasted, and returns nobody publishes.</p>
            </div>
            <figure className="lp-quote-card lp-float" data-lp-reveal data-lp-delay="120">
                <div className="mk">“</div>
                <blockquote>Angels invest on gut feel — not because they want to, but because deal sizes of £25k–£500k were always too small to justify external diligence. Until now.</blockquote>
            </figure>
        </div>
    </section>
);

export default AngelProblemSection;
